import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

const anomalyParamsSerializer = (p) => {
  const sp = new URLSearchParams();
  Object.entries(p).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (Array.isArray(v)) {
      v.forEach((item) => sp.append(k, item));
    } else {
      sp.append(k, v);
    }
  });
  return sp.toString();
};

const anomalyGetConfig = (params) => ({
  params,
  paramsSerializer: anomalyParamsSerializer,
});

export default class AnomalyService {
  static getList(params) {
    return HttpUtil.get(API_ROUTES.ANOMALY.LIST, anomalyGetConfig(params));
  }

  static getById(id) {
    return HttpUtil.get(API_ROUTES.ANOMALY.SINGLE.replace("<id>", id));
  }

  static getSummary(params) {
    return HttpUtil.get(API_ROUTES.ANOMALY.SUMMARY, { params });
  }

  static getStats(params) {
    return HttpUtil.get(API_ROUTES.ANOMALY.STATS, { params });
  }

  static dismiss(payload) {
    return HttpUtil.post(API_ROUTES.ANOMALY.DISMISS, payload);
  }

  static revokeSuppression(id) {
    return HttpUtil.post(API_ROUTES.ANOMALY.REVOKE.replace("<id>", id), {});
  }

  static fix(id, payload) {
    return HttpUtil.patch(
      API_ROUTES.ANOMALY.FIX.replace("<id>", id),
      payload
    );
  }

  static getTimeSeries(params) {
    return HttpUtil.get(API_ROUTES.ANOMALY.TIMESERIES, { params });
  }

  static exportPdf(params) {
    return HttpUtil.getPDFData(API_ROUTES.ANOMALY.EXPORT_PDF, anomalyGetConfig(params));
  }

  static exportExcel(params) {
    return HttpUtil.getExcelData(API_ROUTES.ANOMALY.EXPORT_EXCEL, anomalyGetConfig(params));
  }

  static getRuleConfigs() {
    return HttpUtil.get(API_ROUTES.ANOMALY.RULE_CONFIGS);
  }

  static updateRuleConfig(payload) {
    return HttpUtil.put(API_ROUTES.ANOMALY.RULE_CONFIGS, payload);
  }

  static toggleRuleConfig(ruleCode, enabled) {
    return HttpUtil.patch(
      API_ROUTES.ANOMALY.RULE_CONFIG_TOGGLE.replace("<ruleCode>", ruleCode) +
        "?enabled=" + enabled
    );
  }

  static getBranchDrilldown(parentBranchId, params = {}) {
    return HttpUtil.get(API_ROUTES.ANOMALY.BRANCH_DRILLDOWN, { params: { parentBranchId, ...params } });
  }

  static runDetect(regulationId, period) {
    const qs = new URLSearchParams({ regulationId, period }).toString();
    return HttpUtil.post(`${API_ROUTES.ANOMALY.DETECT}?${qs}`, {});
  }

  static getDetectStatus(id) {
    return HttpUtil.get(
      API_ROUTES.ANOMALY.DETECT_STATUS.replace("<id>", id)
    );
  }

  static runDetectBackfill(regulationId, payload = {}) {
    const qs = new URLSearchParams({ regulationId }).toString();
    return HttpUtil.post(`${API_ROUTES.ANOMALY.DETECT_BACKFILL}?${qs}`, payload);
  }
}
